import React, { FC, ReactNode, useEffect } from 'react';
import classNames from 'classnames';
import { RouteComponentProps } from 'react-router';
import styles from './assets/serviceType-edit-screen.module.scss';
import Loader from 'src/components/Loader';
import AdminLayout from 'src/components/layout/RoleLayout';
import Form from '../../components/ServiceTypeForm';
import { IServiceType } from 'src/types/service-types';
import { routes } from '../../../../../../navigation';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';
import { QueryParams } from '../../../../../../types/grid';

export interface StateProps {
    serviceType: IServiceType | null;
    inProgress: boolean;
    providers: { title: string; id: number | string }[];
}

export interface DispatchProps {
    getData: (id: string | number) => void;
    getProviders: (params: QueryParams) => void;
}

interface RouteParams {
    id: number;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export type OwnProps = RouteComponentProps<RouteParams>;

export interface Props extends StateProps, DispatchProps, OwnProps {}

const ServiceTypeEditScreen: FC<Props> = (props: Props) => {
    const {
        match: {
            params: { id },
        },
        serviceType,
        // providers,
        inProgress,
        getData,
        getProviders,
    } = props;

    //const provInitVal: any = [];

    useEffect(() => {
        if (!serviceType || serviceType.id !== id) {
            getData(id);
            getProviders({ page: 1, itemsPerPage: 9000 });
        }
        // eslint-disable-next-line
    }, [getProviders, getData]);


    if (!serviceType || inProgress) {
        return <Loader />;
    }

    return (
        <AdminLayout>
            <Breadcrumbs
                items={[
                    { name: 'SERVICE TYPES', path: routes.SERVICE_TYPES_LIST },
                    { name: `EDIT SERVICE TYPE`, path: '' },
                ]}
            />
            <div className={classNames(styles.editWrap)}>
                <Form initialValues={{ isEvaluation: false, ...serviceType }} />
            </div>
        </AdminLayout>
    );
};

export default ServiceTypeEditScreen;
